// Sport scoring/period configuration used by the live Match Control dialog.
// Values here drive the clock (halfLength → minutes per half), available periods
// dropdown, scoring-event buttons, and extra-time thresholds.
export const SPORT_CONFIGS = {
  soccer: {
    name: 'Soccer',
    halfLength: 45,
    periods: ['1H', 'HT', '2H', 'ET1', 'ET2', 'PEN'],
    extraTimeStart: 90,
    scoring: [{ type: 'goal', label: 'Goal', points: 1, emoji: '⚽' }],
  },
  rugby: {
    name: 'Rugby',
    halfLength: 40,
    periods: ['1H', 'HT', '2H', 'ET'],
    extraTimeStart: 80,
    scoring: [
      { type: 'try', label: 'Try', points: 5, emoji: '🏉' },
      { type: 'conversion', label: 'Conversion', points: 2, emoji: '🥅' },
      { type: 'penalty', label: 'Penalty', points: 3, emoji: '🎯' },
      { type: 'dropgoal', label: 'Drop Goal', points: 3, emoji: '🦵' },
    ],
  },
  gaelic_football: {
    name: 'Gaelic Football',
    halfLength: 30,
    periods: ['1H', 'HT', '2H', 'ET'],
    extraTimeStart: 60,
    scoring: [
      { type: 'goal', label: 'Goal', points: 3, emoji: '🥅' },
      { type: 'point', label: 'Point', points: 1, emoji: '🏐' },
    ],
  },
  gaelic_football_intercounty: {
    name: 'Gaelic Football (Inter-County)',
    halfLength: 35,
    periods: ['1H', 'HT', '2H', 'ET'],
    extraTimeStart: 70,
    scoring: [
      { type: 'goal', label: 'Goal', points: 3, emoji: '🥅' },
      { type: 'point', label: 'Point', points: 1, emoji: '🏐' },
    ],
  },
  hurling: {
    name: 'Hurling / Camogie',
    halfLength: 30,
    periods: ['1H', 'HT', '2H', 'ET'],
    extraTimeStart: 60,
    scoring: [
      { type: 'goal', label: 'Goal', points: 3, emoji: '🥅' },
      { type: 'point', label: 'Point', points: 1, emoji: '🏑' },
    ],
  },
  hurling_intercounty: {
    name: 'Hurling / Camogie (Inter-County)',
    halfLength: 35,
    periods: ['1H', 'HT', '2H', 'ET'],
    extraTimeStart: 70,
    scoring: [
      { type: 'goal', label: 'Goal', points: 3, emoji: '🥅' },
      { type: 'point', label: 'Point', points: 1, emoji: '🏑' },
    ],
  },
};

export const GAA_SPORTS = ['gaelic_football', 'gaelic_football_intercounty', 'hurling', 'hurling_intercounty'];

export const isGAASport = (sport) => GAA_SPORTS.includes(sport);

/** Format GAA score as `G-PP` (e.g. 1-07). */
export const formatGAAScore = (goals, points) => `${goals || 0}-${String(points || 0).padStart(2, '0')}`;

export default SPORT_CONFIGS;
